<div *ngIf="reservation.security_deposit">
  <div class="grid grid-flow-col items-center justify-between mb-2 gap-2">
    <div class="text-night-darker text-sm strong">Security deposit</div>

    <!-- TO DO: Once we have a RETRYING status, add this class -->
    <!-- [class.text-raspberry-darker]="reservation.security_deposit.status === status.RETRYING" -->
    <div
      class="strong text-sm ellipsis"
      [class.text-raspberry-darker]="!reservation.security_deposit.status"
      [class.text-grass-darker]="reservation.security_deposit.status === status.SECURED">
      {{ reservation.security_deposit.status || 'pending' | humanize | titlecase }}
    </div>
  </div>

  <div class="text-night-lighter text__small">
    {{ reservation.security_deposit.amount?.formatted_string }} deposit ({{
      reservation.security_deposit.secure_at | date: 'MMM d'
    }}
    - {{ reservation.security_deposit.release_at | date: 'MMM d' }})
  </div>

  @if (reservation.security_deposit.status === status.SECURED) {
    <sbnb-button class="mt-4 block" size="mini" type="secondary" [fullWidth]="true" (clicked)="charge()"
      >Charge deposit</sbnb-button
    >
  }
</div>
